import {useContext} from "react";
import {ClientEntityContextValue} from "../context";
import {ClientEntityContext} from "./ClientEntityContext";

export function useClientEntity(): ClientEntityContextValue {
  return useContext(ClientEntityContext);
}
